<ng-template #titleTpl>
  <!-- Sin ID, dirección ni puesto en el encabezado: el ID ya está en el listado
       desde donde se abre el modal, y los otros dos repetían casi palabra por
       palabra ("Dirección de X" / "Director de X"), comiendo renglones en
       mayúsculas. Los tres viven en el detalle de abajo.

       El estado va en el subtítulo, en su propio renglón, y no como badge a la
       derecha del título. A diferencia del modal del empleado, este conserva el
       nombre técnico del estatus — Director y RH trabajan con el flujo y esperan
       verlo tal cual. -->
  <!-- El `<intelishs-status-text>` es hijo ESTÁTICO del `page-header`, y tiene
       que serlo: la proyección se resuelve contra los hijos estáticos al crear
       el componente, así que un elemento envuelto en `@if` vive en una vista
       embebida, no casa con `select="[slot=subtitulo]"` y —al no haber
       `<ng-content>` catch-all— se descarta EN SILENCIO. Por eso la condición
       duplica el encabezado en vez de envolver lo proyectado. -->
  @if (solicitud(); as sol) {
    @if (soloSaldo()) {
      <intelishs-page-header [title]="sol.empleadoNombre" />
    } @else {
      <intelishs-page-header [title]="sol.empleadoNombre">
        <intelishs-status-text slot="subtitulo" [tone]="getEstatusTono(sol.estatus)">
          {{ sol.estatus }}
        </intelishs-status-text>
      </intelishs-page-header>
    }
  }
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  nzWidth="640px"
  [nzFooter]="null"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    <nz-spin [nzSpinning]="loadingSaldo()">
      @if (solicitud(); as sol) {
        <!-- ── Sección 1: Saldo ─────────────────────────────────────── -->
        @if (saldo(); as s) {
          <!-- Sin section-header: esta sección abre el modal y su línea quedaba
               a unos pixeles de la del encabezado, leyéndose como una raya
               doble. Las siguientes sí lo llevan —ahí sí separan bloques—. -->
          <div class="detalle-seccion">
            @if (modo() === 'director') {
              <!-- Mismo lenguaje que la zona de saldo de solicitar-vacaciones:
                   total primero, ciclos después. Antes cada ciclo era una card
                   con barra de color a la izquierda que contenía tres mini-cards
                   grises: cajas dentro de cajas para tres cifras. -->
              <div class="saldo-total">
                <span class="saldo-total-lbl">Total disponible</span>
                @switch (lecturaSaldo()?.tipo) {
                  @case ('deuda') {
                    <span class="saldo-total-val saldo-total-val--negativo">
                      −{{ s.diasNegativo | number: '1.1-1' }} días
                    </span>
                    <span class="saldo-total-nota">se compensa con los días que genere</span>
                  }
                  @case ('comprometido') {
                    <span class="saldo-total-val">0 días hoy</span>
                    <span class="saldo-total-nota saldo-total-nota--neutra">
                      {{ -s.diasDisponiblesTotal | number: '1.1-1' }} pedidos a cuenta de lo que genere antes de
                      esas fechas
                    </span>
                  }
                  @default {
                    <span class="saldo-total-val">{{ s.diasDisponiblesTotal | number: '1.1-1' }} días</span>
                  }
                }
              </div>
              <ng-container [ngTemplateOutlet]="notaDescuento" />

              <div class="ciclos">
                @if (getPeriodoAnterior(s.periodos); as pa) {
                  <div class="ciclo">
                    <div class="ciclo-head">
                      <span class="ciclo-nombre">Ciclo anterior</span>
                      @if (pa.diasDisponibles > 0) {
                        <intelishs-status-text tone="ok">Vigente</intelishs-status-text>
                      } @else {
                        <intelishs-status-text tone="neutro">Agotado</intelishs-status-text>
                      }
                    </div>
                    <p class="ciclo-dato">
                      <span class="ciclo-val" [class.ciclo-val--negativo]="pa.diasDisponibles < 0">
                        {{ pa.diasDisponibles | number: '1.1-1' }}
                      </span>
                      <span class="ciclo-unidad">días disponibles</span>
                    </p>
                    <p class="ciclo-vigencia">
                      Vence el {{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}
                    </p>
                    <p class="ciclo-desglose">
                      {{ pa.diasCorrespondientes }} por ley ·
                      {{ pa.diasUsados | number: '1.1-1' }} usados
                    </p>
                  </div>
                }

                @if (getPeriodoAnteriorVencido(s.periodos); as pa) {
                  <div class="ciclo ciclo--apagado">
                    <div class="ciclo-head">
                      <span class="ciclo-nombre">Ciclo anterior</span>
                      <intelishs-status-text tone="neutro">Vencido</intelishs-status-text>
                    </div>
                    <p class="ciclo-dato">
                      <span class="ciclo-val">0</span>
                      <span class="ciclo-unidad">días disponibles</span>
                    </p>
                    <p class="ciclo-vigencia">
                      Venció el {{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}
                    </p>
                    <p class="ciclo-desglose">
                      {{ pa.diasCorrespondientes }} por ley ·
                      {{ pa.diasUsados | number: '1.1-1' }} usados
                    </p>
                  </div>
                }

                @if (getPeriodoActual(s.periodos); as pc) {
                  <div class="ciclo">
                    <div class="ciclo-head">
                      <span class="ciclo-nombre">Ciclo actual</span>
                      <intelishs-status-text tone="progreso">Acumulando</intelishs-status-text>
                    </div>
                    <p class="ciclo-dato">
                      <span class="ciclo-val" [class.ciclo-val--negativo]="pc.diasDisponibles < 0">
                        {{ pc.diasDisponibles | number: '1.1-1' }}
                      </span>
                      <span class="ciclo-unidad">días disponibles</span>
                    </p>
                    <p class="ciclo-vigencia">
                      Aniversario el {{ pc.fechaAniversario | date: 'dd/MM/yyyy' }}
                    </p>
                    <p class="ciclo-desglose">
                      {{ pc.diasCorrespondientes }} al finalizar ·
                      {{ pc.diasGenerados | number: '1.1-1' }} generados
                    </p>
                  </div>
                }

                @if (!getPeriodoAnterior(s.periodos) && !getPeriodoActual(s.periodos)) {
                  <ng-container [ngTemplateOutlet]="saldoResumen" />
                }
              </div>
            } @else {
              <!-- Vista simple (RH y Admin) -->
              <ng-container [ngTemplateOutlet]="saldoResumen" />
            }
          </div>
        }

        <!-- ── Sección 2: Detalle de la solicitud (si no es solo-saldo) ─ -->
        @if (!soloSaldo()) {
          @if (incumplePoliticaAnticipacion(sol.fechaSolicitud, sol.fechaInicio)) {
            <div class="aviso aviso--warning">
              <nz-icon nzType="warning" />
              <span>Solicitud fuera de política — menos de 2 semanas de anticipación</span>
            </div>
          }
          <div class="detalle-seccion">
            <intelishs-section-header title="Detalle de la Solicitud" />
            <div class="seccion-panel">
              <div class="grid-periodo">
                <app-detail-field label="Días hábiles" layout="stacked">{{
                  sol.diasSolicitados
                }}</app-detail-field>
                <app-detail-field label="Solicitada" layout="stacked">{{
                  sol.fechaSolicitud | date: 'dd/MM/yyyy'
                }}</app-detail-field>
                <app-detail-field label="Fecha inicio" layout="stacked">{{
                  sol.fechaInicio | date: 'dd/MM/yyyy'
                }}</app-detail-field>
                <app-detail-field label="Fecha fin" layout="stacked">{{
                  sol.fechaFin | date: 'dd/MM/yyyy'
                }}</app-detail-field>
              </div>
              <!-- Área y dirección juntas (misma dimensión: dónde trabaja) y el
                   puesto aparte (qué hace). Bajan del encabezado, donde el
                   puesto se comía renglones en mayúsculas. Ancho completo: son
                   los textos largos de la sección. -->
              <app-detail-field label="Área / Dirección" layout="stacked" [full]="true">{{
                describirAdscripcion(sol)
              }}</app-detail-field>
              @if (sol.puesto) {
                <app-detail-field label="Puesto" layout="stacked" [full]="true">{{
                  sol.puesto
                }}</app-detail-field>
              }
              <!-- El comentario del empleado es parte de la solicitud —lo
                   escribió al pedirla, y su fecha es la de "Solicitada"—, no una
                   resolución. Vivía en la línea de tiempo de abajo, mezclado con
                   las de Director y RH y a dos secciones de distancia de los
                   datos que explica. Mismo sitio que en el modal de aprobar. -->
              @if (sol.comentarios) {
                <app-detail-field label="Comentario del empleado" layout="stacked" [full]="true">
                  {{ sol.comentarios }}
                </app-detail-field>
              }
            </div>
          </div>

          <!-- ── Sección 3: Flujo de aprobación ───────────────────
               SIEMPRE visible: son los pasos del proceso, no solo los resueltos.
               Estaba condicionada a que alguien hubiera resuelto, así que una
               solicitud recién enviada —justo la que se abre desde "Pendientes
               del director"— no mostraba nada, y esa ausencia era ambigua: no
               distinguía "nadie ha resuelto todavía" de "este modal no muestra
               flujo". Con los pasos completos, el que está en curso aparece en
               naranja, que es el dato más accionable de una solicitud abierta:
               de quién es el turno. -->
          <div class="detalle-seccion">
            <intelishs-section-header title="Flujo de Aprobación" />

            @if (getResultadoTipo(sol)) {
              <div class="resultado-banner resultado-banner--{{ getResultadoTipo(sol) }}">
                <nz-icon
                  [nzType]="
                    getResultadoTipo(sol) === 'success'
                      ? 'check-circle'
                      : getResultadoTipo(sol) === 'danger'
                        ? 'close-circle'
                        : 'stop'
                  "
                />
                <div class="resultado-texto">
                  <span class="resultado-titulo">{{ getResultadoTexto(sol) }}</span>
                  @if (getResultadoMotivo(sol)) {
                    <span class="resultado-motivo">"{{ getResultadoMotivo(sol) }}"</span>
                  }
                </div>
              </div>
            }

            <!-- Mismo vocabulario `.tl-*` y la MISMA máquina de estados que
                   el rastreador del empleado (`getPasosFlujo`): la solicitud es
                   una sola y su relato no puede cambiar según quién la mire. Lo
                   que cambia es el contenido —aquí van el nombre de quien
                   resolvió y su comentario, que al empleado se le ocultan a
                   propósito, y no va el texto en segunda persona—.

                   Orden cronológico: enviada, director, RH. Antes RH iba
                   arriba, o sea el paso 2 sobre el paso 1, en una sección
                   titulada "Flujo". -->
            <ol class="tl">
              @for (paso of pasos(sol); track paso.titulo) {
                <li class="tl-item" [class]="'tl-item--' + paso.estado">
                  <span class="tl-dot"></span>
                  <div class="tl-body">
                    <div class="tl-head">
                      <span class="tl-titulo">{{ paso.titulo }}</span>
                      @if (paso.fecha) {
                        <span class="tl-fecha">{{ paso.fecha | date: 'dd/MM/yyyy' }}</span>
                      }
                    </div>
                    @if (paso.nombre) {
                      <p class="tl-autor">{{ paso.nombre }}</p>
                    }
                    @if (paso.comentario) {
                      <p class="tl-comentario">{{ paso.comentario }}</p>
                    }
                  </div>
                </li>
              }
            </ol>
          </div>
        }
      }
    </nz-spin>
  </ng-template>
</nz-modal>

<!-- Resumen de saldo sin ciclos. Lo usan la vista de RH/Admin y la del director
     cuando el empleado no tiene periodos: mismo lenguaje que el hero de la
     vista con ciclos —total primero, contexto después— en lugar de las cuatro
     cajas iguales que había.

     Eran cuatro cifras del mismo peso que NO son cuatro pares: la antigüedad es
     lo que determina los días por LFT, y el disponible viene de otro cálculo. Al
     alinearlas invitaban a una resta que no cierra —18 por LFT menos 14 usados
     no da 13 disponibles, porque el disponible acumula ciclos—. -->
<ng-template #saldoResumen>
  @if (saldo(); as s) {
    <div class="saldo-total">
      <span class="saldo-total-lbl">Total disponible</span>
      @switch (lecturaSaldo()?.tipo) {
        @case ('deuda') {
          <span class="saldo-total-val saldo-total-val--negativo">
            −{{ s.diasNegativo | number: '1.1-1' }} días
          </span>
          <span class="saldo-total-nota">se compensa con los días que genere</span>
        }
        @case ('comprometido') {
          <span class="saldo-total-val">0 días hoy</span>
          <span class="saldo-total-nota saldo-total-nota--neutra">
            {{ -s.diasDisponiblesTotal | number: '1.1-1' }} pedidos a cuenta de lo que genere antes de
            esas fechas
          </span>
        }
        @default {
          <span class="saldo-total-val">{{ s.diasDisponiblesTotal | number: '1.1-1' }} días</span>
        }
      }
    </div>
    <ng-container [ngTemplateOutlet]="notaDescuento" />
    <p class="saldo-contexto">
      {{ s.antiguedadAnios }} {{ s.antiguedadAnios === 1 ? 'año' : 'años' }} de antigüedad ·
      {{ s.diasCorrespondientes }} días por LFT · {{ s.diasUsadosTotal | number: '1.1-1' }} usados
    </p>
  }
</ng-template>

<!-- El saldo que devuelve el backend YA trae descontados los días de esta
     solicitud: lo pendiente se reserva para que dos solicitudes simultáneas no
     gasten el mismo día. Sin decirlo, quien autoriza leía "Total disponible
     13.4 días" como el saldo actual del empleado, cuando 13.4 es lo que le
     quedaría —hoy tiene 24.4— y decidía sobre la proyección de la propia
     solicitud que estaba revisando.

     El modal de aprobación ya lo desglosa en tres renglones; aquí basta con
     nombrarlo, porque este modal informa y no es donde se decide. -->
<ng-template #notaDescuento>
  @if (diasDescontados(); as dias) {
    <p class="saldo-descuento">
      Ya descontados los {{ dias }} {{ dias === 1 ? 'día' : 'días' }} de esta solicitud
    </p>
  }
</ng-template>
